import { render, staticRenderFns } from "./showPhoneMessage.vue?vue&type=template&id=57c3566c&scoped=true&"
import script from "./showPhoneMessage.vue?vue&type=script&lang=js&"
export * from "./showPhoneMessage.vue?vue&type=script&lang=js&"
import style0 from "./showPhoneMessage.vue?vue&type=style&index=0&id=57c3566c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c3566c",
  null
  
)

export default component.exports